import { statsData } from '@/mocks/sportsData';

export default function DataSection() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
            赛事数据分析
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-xl mx-auto">
            基于海量赛事数据的专业分析模型，为你提供最精准的比赛预测与深度洞察
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {statsData.map((stat) => (
            <div
              key={stat.label}
              className="flex flex-col items-center text-center p-6 md:p-8 rounded-xl bg-background-50 border border-background-200/70 hover:border-accent-200 transition-all duration-300"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mb-4">
                <i className={`${stat.icon} text-xl md:text-2xl`}></i>
              </div>
              <p className="font-heading text-2xl md:text-3xl font-bold text-primary-600">{stat.value}</p>
              <p className="mt-1 text-sm font-medium text-foreground-800">{stat.label}</p>
              <p className="mt-1 text-xs text-foreground-500">{stat.description}</p>
            </div>
          ))}
        </div>

        <div className="mt-10 md:mt-14 p-6 md:p-8 rounded-xl bg-accent-50 border border-accent-200/60">
          <div className="flex flex-col lg:flex-row items-center gap-6 md:gap-8">
            <div className="flex-shrink-0 w-16 h-16 md:w-20 md:h-20 flex items-center justify-center rounded-full bg-accent-500 text-background-50">
              <i className="ri-bar-chart-grouped-line text-2xl md:text-3xl"></i>
            </div>
            <div className="flex-1 text-center lg:text-left">
              <h3 className="font-semibold text-lg text-foreground-900">独家数据模型，精准赛事预测</h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
                九游体育自主研发的AI赛事分析系统，结合历史数据、球员状态、战术风格等50万+数据维度，为你提供全方位比赛洞察
              </p>
            </div>
            <button className="flex-shrink-0 px-6 py-3 rounded-full bg-accent-500 text-background-50 font-semibold text-sm hover:bg-accent-600 transition-colors duration-200 whitespace-nowrap cursor-pointer">
              了解更多
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}